import { render } from "./musicPlayer.vue?vue&type=template&id=40b2b2d2&scoped=true"
import script from "./musicPlayer.vue?vue&type=script&lang=js"
export * from "./musicPlayer.vue?vue&type=script&lang=js"

import "./musicPlayer.vue?vue&type=style&index=0&id=40b2b2d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40b2b2d2"

export default script